import { createFeatureSelector, createSelector } from '@ngrx/store';
import { pricingInputsFeatureKey, PricingInputsState } from './pricing-inputs.reducer';
import { PricingInputResponse } from 'src/app/models/pricing-view-models';

export const selectPricingInputsState =
  createFeatureSelector<PricingInputsState>(pricingInputsFeatureKey);

// export const selectAllProjects = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.projects
// );

// export const selectProjectsSearchResult = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => ({
//     projects: state.projects,
//     qtyOfProjects: state.qtyOfProjects,
//     qtyOfActiveProjects: state.qtyOfActiveProjects,
//     qtyOfInactiveProjects: state.qtyOfInactiveProjects,
//     qtyOfProjectsForCurrentUser: state.qtyOfProjectsForCurrentUser,
//     projectEvents: state.projectEvents,
//     searchRequest: state.searchRequest,
//     focusedProject: state.focusedProject
//   })
// );

// export const selectQtyOfInactiveProjects = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.qtyOfInactiveProjects
// );

// export const selectQtyOfActiveProjects = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.qtyOfActiveProjects
// );

// export const selectQtyOfProjectsForCurrentUser = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.qtyOfProjectsForCurrentUser
// );

// export const selectProjectEvents = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.projectEvents
// );

// export const selectFocusedProject = createSelector(
//   selectProjectsState,
//   (state: ProjectsState) => state.focusedProject
// );

export const selectPricingInputsSearchResult = createSelector(
  selectPricingInputsState,
  (state: PricingInputsState) => {
     let rtn = {} as PricingInputResponse;
     rtn.CodeStringGroups = state.pricingInputResponse.CodeStringGroups;
     rtn.ProductModelValues = state.pricingInputResponse.ProductModelValues;
     rtn.ProjectScheduleLineItemPricing = state.pricingInputResponse.ProjectScheduleLineItemPricing;
     return rtn;
  }
);

export const selectPricingInputRequest = createSelector(
  selectPricingInputsState,
  (state: PricingInputsState) => state.pricingInputRequest
  // (state: PricingInputsState) => {
  //   let rtn = {} as PricingInputsState;
  //   rtn.pricingInputRequest = state.pricingInputRequest;
  //   rtn.pricingInputResponse = state.pricingInputResponse;
  //   return rtn;
  // }
);
